// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__35ZKX","choiceBoxes":"toolbarselects_choiceBoxes__1rOvl","simpleField":"toolbarselects_simpleField__3_YIV"};